import React, { useState } from "react";
import toast from "react-hot-toast";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useSchoolParentApi } from "../../../../utils/useSchoolParentApi";

const validationSchema = Yup.object({
  currentPassword: Yup.string().required("Current password is required"),
  newPassword: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords do not match")
    .required("Confirm password is required"),
});

const UpdatePasswordForm = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { apiCall } = useSchoolParentApi();

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      await apiCall(`${apiUrl}/auth/update-password`, {
        method: "POST",
        body: JSON.stringify({
          current_password: values.currentPassword,
          password: values.newPassword,
        }),
      });

      toast.success("Password updated successfully!");
      resetForm();
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to update password.",
      );
    } finally {
      setSubmitting(false); // 🔥 important
    }
  };

  return (
    <Formik
      initialValues={{
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, handleChange, isSubmitting }) => (
        <Form className="mt-4">
          {/* Current Password */}
          <div className="mb-3 row">
            <label className="col-form-label col-12 col-md-3 addSchlAcuntFormLabelKids">
              Current Password
            </label>

            <div className="col-12 col-md-9 position-relative">
              <input
                type={showCurrent ? "text" : "password"}
                name="currentPassword"
                className="form-control pe-5"
                value={values.currentPassword}
                onChange={handleChange}
              />

              <i
                className={`fa ${showCurrent ? "fa-eye" : "fa-eye-slash"} position-absolute top-50 end-0 translate-middle-y me-4`}
                style={{ cursor: "pointer" }}
                onClick={() => setShowCurrent(!showCurrent)}
              />
              <ErrorMessage
                name="currentPassword"
                component="div"
                className="text-danger small mt-1"
              />
            </div>
          </div>

          {/* New Password */}
          <div className="mb-3 row">
            <label className="col-form-label col-12 col-md-3 addSchlAcuntFormLabelKids">
              New Password
            </label>

            <div className="col-12 col-md-9 position-relative">
              <input
                type={showNew ? "text" : "password"}
                name="newPassword"
                className="form-control pe-5"
                value={values.newPassword}
                onChange={handleChange}
              />

              <i
                className={`fa ${showNew ? "fa-eye" : "fa-eye-slash"} position-absolute top-50 end-0 translate-middle-y me-4`}
                style={{ cursor: "pointer" }}
                onClick={() => setShowNew(!showNew)}
              />
              <ErrorMessage
                name="newPassword"
                component="div"
                className="text-danger small mt-1"
              />
            </div>
          </div>

          {/* Confirm Password */}
          <div className="mb-3 row">
            <label className="col-form-label col-12 col-md-3 addSchlAcuntFormLabelKids">
              Confirm Password
            </label>

            <div className="col-12 col-md-9 position-relative">
              <input
                type={showConfirm ? "text" : "password"}
                name="confirmPassword"
                className="form-control pe-5"
                value={values.confirmPassword}
                onChange={handleChange}
              />

              <i
                className={`fa ${showConfirm ? "fa-eye" : "fa-eye-slash"} position-absolute top-50 end-0 translate-middle-y me-4`}
                style={{ cursor: "pointer" }}
                onClick={() => setShowConfirm(!showConfirm)}
              />
              <ErrorMessage
                name="confirmPassword"
                component="div"
                className="text-danger small mt-1"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="text-white mt-4 tchrdashboard-cmnbtn border-0 d-flex align-items-center justify-content-center gap-2"
          >
            {isSubmitting ? (
              <>
                <i className="fa fa-spinner fa-spin"></i>
                Updating...
              </>
            ) : (
              "Update Password"
            )}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default UpdatePasswordForm;
